exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".damageResultUptec .container-result {\n  background-color: #F3F3F3;\n  padding: 1.8rem 1.2rem;\n}\n.damageResultUptec .containerImgProduct img {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  height: 15rem;\n}\n.damageResultUptec .images-list_container li {\n  width: 6rem;\n  height: 6rem;\n  margin-right: 1rem;\n  display: inline-block;\n}\n.damageResultUptec .images-list_container li img {\n  height: 100%;\n  width: 100%;\n  border-radius: 7%;\n}", ""]);

// exports
